export class HMD {
  negativeResponseCount: number;

  offerCount: number;

  totalResponseCount: number;

  positiveResponseCount: number;

  adjustedPositiveRepeatResponseCount: number;

  lastUpdated: string;

  offerLastUpdated: string;

  tenuredAvgResponseYesCount: number;

  tenuredAvgResponseNoCount: number;

  tenuredAvgAdjustedResponseYesCount: number;

  tenuredAvgAdjustedResponseNoCount: number;

  constructor({
    negativeResponseCount,
    offerCount,
    totalResponseCount,
    positiveResponseCount,
    adjustedPositiveRepeatResponseCount,
    lastUpdated,
    offerLastUpdated,
    tenuredAvgResponseYesCount,
    tenuredAvgResponseNoCount,
    tenuredAvgAdjustedResponseYesCount,
    tenuredAvgAdjustedResponseNoCount,
  }: Record<string, any>) {
    this.negativeResponseCount = negativeResponseCount;
    this.offerCount = offerCount;
    this.totalResponseCount = totalResponseCount;
    this.positiveResponseCount = positiveResponseCount;
    this.adjustedPositiveRepeatResponseCount =
      adjustedPositiveRepeatResponseCount;
    this.lastUpdated = lastUpdated;
    this.offerLastUpdated = offerLastUpdated;
    this.tenuredAvgResponseYesCount = tenuredAvgResponseYesCount;
    this.tenuredAvgResponseNoCount = tenuredAvgResponseNoCount;
    this.tenuredAvgAdjustedResponseYesCount =
      tenuredAvgAdjustedResponseYesCount;
    this.tenuredAvgAdjustedResponseNoCount = tenuredAvgAdjustedResponseNoCount;
  }

  calculatePRRScore(): string {
    return (
      (this.positiveResponseCount /
        (this.negativeResponseCount + this.positiveResponseCount)) *
      100
    ).toFixed(2);
  }

  calculatePRRSum(): number {
    return this.negativeResponseCount + this.positiveResponseCount;
  }

  calculatePRRAverage(): string {
    return this.tenuredAvgResponseYesCount + this.tenuredAvgResponseNoCount > 0
      ? (
          (this.tenuredAvgResponseYesCount /
            (this.tenuredAvgResponseYesCount +
              this.tenuredAvgResponseNoCount)) *
          100
        ).toFixed(2)
      : '0';
  }

  calculateOfferScore(): string {
    return ((this.totalResponseCount / this.offerCount) * 100).toFixed(2);
  }

  calculateOfferSum(): number {
    return this.totalResponseCount + this.offerCount;
  }

  calculateRAPScore(): string {
    return (
      ((this.positiveResponseCount - this.adjustedPositiveRepeatResponseCount) /
        (this.negativeResponseCount + this.positiveResponseCount)) *
      100
    ).toFixed(2);
  }

  calculateRAPSum(): number {
    return (
      this.positiveResponseCount +
      this.adjustedPositiveRepeatResponseCount +
      this.negativeResponseCount
    );
  }

  calculateRAPAverage(): string {
    return this.tenuredAvgAdjustedResponseYesCount +
      this.tenuredAvgAdjustedResponseNoCount >
      0
      ? (
          (this.tenuredAvgAdjustedResponseYesCount /
            (this.tenuredAvgAdjustedResponseYesCount +
              this.tenuredAvgAdjustedResponseNoCount)) *
          100
        ).toFixed(2)
      : '0';
  }
}

export const EmptyHMD: HMD = {
  negativeResponseCount: 0,
  offerCount: 0,
  totalResponseCount: 0,
  positiveResponseCount: 0,
  adjustedPositiveRepeatResponseCount: 0,
  lastUpdated: '',
  offerLastUpdated: '',
  tenuredAvgResponseYesCount: 0,
  tenuredAvgResponseNoCount: 0,
  tenuredAvgAdjustedResponseYesCount: 0,
  tenuredAvgAdjustedResponseNoCount: 0,
  calculatePRRScore: HMD.prototype.calculatePRRScore,
  calculatePRRSum: HMD.prototype.calculatePRRSum,
  calculatePRRAverage: HMD.prototype.calculatePRRAverage,
  calculateOfferScore: HMD.prototype.calculateOfferScore,
  calculateOfferSum: HMD.prototype.calculateOfferSum,
  calculateRAPScore: HMD.prototype.calculateRAPScore,
  calculateRAPSum: HMD.prototype.calculateRAPSum,
  calculateRAPAverage: HMD.prototype.calculateRAPAverage,
};
